<template>
  <v-snackbar
    :class="{ snackbar_text_center: !showClose }"
    v-model="visible"
    :bottom="y === 'bottom'"
    :color="color"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :rounded="rounded"
    :timeout="timeout"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
  >
    {{ message }}
    <template v-if="showClose" v-slot:action="{ attrs }">
      <v-btn dark text v-bind="attrs" @click="visible = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'snackbar',
  data: () => ({
    visible: false,
    message: '',
    timeout: 2000,
    color: '',
    mode: '',
    x: null,
    y: 'bottom',
    rounded: 'pill',
    showClose: false
  }),
  watch: {
    visible (val) {
      if (!val) {
        this.$emit('close')
        this.$destroy()
      }
    }
  }
}
</script>

<style lang="scss">
.snackbar_text_center {
  .v-snack__content {
    text-align: center;
  }
}
</style>
